import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';

export const PHOTO_GALLERY_TOUR_ID = 'photo-gallery.intro';

registerTour({
  id: PHOTO_GALLERY_TOUR_ID,
  name: 'Photo Gallery',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.PHOTO_GALLERY.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to the Photo Gallery',
      body:
        'Every photo on the project lives here — uploads from this page ' +
        'plus photos pulled in from observations, punch list items, and drone flights.',
    },
    {
      id: 'upload',
      target: '[data-tour-id="photo-gallery-upload"]',
      placement: 'bottom',
      spotlightPadding: 4,
      title: 'Upload photos',
      body:
        'Drag-and-drop or click to upload. New photos land in the ' +
        '"Gallery" source.',
    },
    {
      id: 'filters',
      target: '[data-tour-id="photo-gallery-filters"]',
      placement: 'bottom',
      spotlightPadding: 4,
      title: 'Search & filter',
      body:
        'Search by filename and narrow down by source (Gallery, ' +
        'Observations, Drone, etc.) or upload date range.',
    },
    {
      id: 'grid',
      target: '[data-tour-id="photo-gallery-grid"]',
      placement: 'top',
      spotlightPadding: 4,
      title: 'Browse photos',
      body:
        'Photos are grouped by upload date. Click any photo to view it ' +
        'full-size in the lightbox.',
    },
  ],
});
